import { ID } from '@app/models';
import { ModelBasic } from '..';
import { TemplateCustomAttributeGroupField } from './customdata';

export interface CustomFieldConfiguration extends ModelBasic {
  reference_type: string;
  sub_type_definitions: CustomFieldSubTypeDefinition[];
  group_specifications: CustomFieldAttributeGroupSpecification[];
  filter_settings: CustomFieldConfigurationFilterSetting[];
}

export interface CustomFieldConfigurationFilterSetting extends ModelBasic {
  value_changes_by: string;
  value_by: string;
  compare_by_values: {
    compare_by: string;
    value: string;
    compare: '==' | '>' | '<' | '>=' | '<=' | '!=';
  }[];
  sub_type_reference_name: string;
}

export interface CustomFieldRelation {
  id: ID;
  relation_name: string;
  table_name: string;
  data_route: string;
  details_data_route: string;
  data_route_variables: CustomFieldRelationTableRouteVariable[];
  display_by: string;
  display_by_array: CustomFieldDisplayByArray[];
  concat_with: string;
  is_multi_selectable: boolean;
  relation_keys: CustomFieldRelationKey[];
  data_array: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data_array_parsed?: any[];
  module_id: string;
  origin_type: string;
  params: CustomFieldRelationParam[];
}

export interface CustomFieldRelationKey {
  key: string;
}

export interface CustomFieldDisplayByArray {
  label: string;
  displayBys: string[];
}
export interface CustomFieldRelationParam extends ModelBasic {
  param_name: string;
  param: string;
  value_by: string;
  param_type: 'QUERY' | 'ROUTE';
}
export interface CustomFieldRelationTableRouteVariable {
  id: ID;
  placeholder: string;
  placeholder_key: string;
  placeholder_default_data: string;
}

export type CustomFieldTypeType =
  | 'string'
  | 'date'
  | 'number'
  | 'bool'
  | 'price'
  | 'selection'
  | 'full-selection'
  | 'full-selection-lazy'
  | 'datetime'
  | 'positionnumber'
  | 'location'
  | 'file_upload'
  | 'multi_file_upload';

export interface CustomFieldType {
  id: ID;
  field_type: CustomFieldTypeType;
  field_type_name: string;
  field_relations: CustomFieldRelation[];
}

export type CustomFieldTagType =
  | 'EVENT'
  | 'ABFAHRTSORT'
  | 'ANKUNFTSORT'
  | 'LIEFERNUMMER'
  | 'DATETIME_START'
  | 'DATETIME_END'
  | 'VEHICLE'
  | 'DRIVER'
  | 'WAYPOINT'
  | 'LKW_LICENSEPLATE'
  | 'LKW_DRIVER'
  | 'SPEDITION'
  | 'DATE_START'
  | 'DATE_END'
  | 'SERVICEPRODUCT'
  | 'LINK_AS_ORIGIN'
  | 'LINK_AS_RESULING'
  | 'PULSE_TIME'
  | 'LAZER_TYPE'
  | string;
export const CustomFieldTags = {
  EVENT: 'EVENT',
  ABFAHRTSORT: 'ABFAHRTSORT',
  ANKUNFTSORT: 'ANKUNFTSORT',
  LIEFERNUMMER: 'LIEFERNUMMER',
  DATETIME_START: 'DATETIME_START',
  DATETIME_END: 'DATETIME_END',
  VEHICLE: 'VEHICLE',
  DRIVER: 'DRIVER',
  WAYPOINT: 'WAYPOINT',
  LKW_LICENSEPLATE: 'LKW_LICENSEPLATE',
  LKW_DRIVER: 'LKW_DRIVER',
  SPEDITION: 'SPEDITION',
  DATE_START: 'DATE_START',
  DATE_END: 'DATE_END',
  SERVICEPRODUCT: 'SERVICEPRODUCT',
  LINK_AS_ORIGIN: 'LINK_AS_ORIGIN',
  LINK_AS_RESULING: 'LINK_AS_RESULING',
  PULSE_TIME: 'PULSE_TIME',
  LAZER_TYPE: 'LAZER_TYPE',
};
export interface CustomFieldTag {
  id: ID;
  tag: CustomFieldTagType;
  tag_name: string;
}

export interface TemplateCustomField {
  id: ID;
  field_type: CustomFieldType;
  field_length: string;
  field_display_name: string;
  field_default_value: string;
  field_rule: string;
  field_relation: CustomFieldRelation;
  print_field: boolean; // gibt an, ob das Drucken des Feldes vorausgewählt ist
  is_required: boolean; // gibt an, ob es ein Pflichtfeld ist
}

export interface CustomFieldTag extends ModelBasic {
  tag: string;
  tag_name: string;
}

export interface CustomFieldSubTypeDefinition
  extends TemplateCustomAttributeGroupField,
    ModelBasic {
  sub_type_reference_name: string;
}

export interface CustomFieldAttributeGroupSpecification extends ModelBasic {
  group_name: string;
  order_value: number;
  fields: CustomFieldAttributeGroupSpecificationField[];
}

export interface CustomFieldAttributeGroupSpecificationField
  extends TemplateCustomAttributeGroupField,
    ModelBasic {
  field_settings: CustomFieldAttributeGroupSpecificationFieldSetting[];
  tags: CustomFieldTag[];
}

export interface CustomFieldAttributeGroupSpecificationFieldSetting
  extends ModelBasic {
  sub_type_definition: CustomFieldSubTypeDefinition;
  field_value: string;
  foreign_id: string;
}

export interface AttributeGroup extends ModelBasic {
  attribute_group: CustomFieldAttributeGroupSpecification;
  group_fields: AttributeGroupField[];
}
export interface AttributeGroupField extends ModelBasic {
  attribute_field: CustomFieldAttributeGroupSpecificationField;
  field_value: string;
  foreign_id: string;
  is_required: boolean;
  params?: { param: string; value: string }[];
}
